
import {Component} from 'vue-property-decorator';
import * as echarts from 'echarts';
import StackedBarChartFilterable from '@/components/reports-v3/components/filterables/StackedBarChartFilterable.vue';
import TableFilterable from '@/components/reports-v3/components/filterables/TableFilterable.vue';
import FilterWidget from '@/components/reports-v3/components/codedWidgets/shared/FilterWidget.vue';
import gdbx from '@/store/modules/gdbx';
import { getTableName, TIMEZONE_OFFSET_MS } from '@/worker/db/sqlHelpers';
import moment from 'moment';

@Component({
  components: {
    StackedBarChartFilterable,
    TableFilterable,
  },
})

export default class InstafreshDashboard extends FilterWidget {

  public get exportFileName() {
    const formattedDate = moment(this.selectedAsOfDate).format('DD MMM YY');
    return 'Daily Sales' + '_' + 'As Of ' + formattedDate;
  }

  public currentTableItems = [];

  public get currencySymbol() {
    return gdbx.currencySymbol;
  }

  public get dateFormatted() {
    return [this.selectedAsOfDate];
  }

  public get expensiveHook() {
    const { selectedAsOfDate, selectedAgents, selectedSuppliers } = this;
    return JSON.stringify([
      selectedAsOfDate,
      selectedAgents,
      selectedSuppliers,
    ]);
  }

  public tableItems: any = [];

  public newTableFields: any [] = [
    {
      key: 'date',
      sortable: true,
      stickyColumn: true,
    }, {
      key: 'doc_type',
      sortable: true,
      stickyColumn: true,
    }, {
      key: 'amount',
      sortable: true,
      stickyColumn: true,
    }, {
      key: 'store_location',
      sortable: true,
      stickyColumn: true,
    },
  ];

  public filterIds: Array<
      | 'date'
      | 'dateAsOf'
      | 'dateRange'
      | 'stockItems'
      | 'agents'
      | 'customers'
      | 'suppliers'
      > = ['suppliers', 'agents', 'dateAsOf'];

  public result: number[] = [];
  public xAxisData: string[] = [];
  public series: echarts.ECharts[] | any = [];

  public get filterTable() {
    return this.currentTableItems = this.tableItems.filter((a) => moment(a.docDate)
        .format('DD MM YY') === moment(this.selectedAsOfDate)
        .format('DD MM YY'))
        .map((a) => {
          return {
            date: moment(a.docDate).format('DD MMM YYYY'),
            doc_type: a.docType,
            amount: this.thousandFormatter(a.localDocAmount),
            store_location: a.storeLocation,
          };
        });
  }

  public async expensiveCalc() {
    const table = getTableName('diyDailyProjectSales');
    const dateExpr = `TRY_CAST("DOCDATE" AS BIGINT)`;
    const dayStart = moment(this.selectedAsOfDate).startOf('day').valueOf();
    const dayEnd = moment(this.selectedAsOfDate).endOf('day').valueOf();

    const jobId = this.currentJobId;
    const queryHead = await this._ensureTablesLoaded(
      ['diyDailyProjectSales'],
    );
    this.checkInterrupted(jobId);

    this.generateLoadingText(0.3);

    const [chartResult, tableResult] = await Promise.all([
      queryHead.rawQuery(`
        SELECT "STORELOCATION" as storeLocation,
          SUM(TRY_CAST("LOCALDOCAMT" AS DOUBLE)) as total
        FROM ${table}
        WHERE ${dateExpr} BETWEEN ${dayStart} AND ${dayEnd}
        GROUP BY "STORELOCATION"
        ORDER BY "STORELOCATION"
      `),
      queryHead.rawQuery(`
        SELECT "DOCTYPE" as docType,
          ${dateExpr} as docDate,
          TRY_CAST("LOCALDOCAMT" AS DOUBLE) as localDocAmount,
          "STORELOCATION" as storeLocation
        FROM ${table}
      `),
    ]);
    this.checkInterrupted(jobId);

    this.xAxisData = chartResult.map((r) => r.storeLocation || '');
    this.result = chartResult.map((r) => Number(r.total) || 0);

    this.series = [
      {
        name: 'Total',
        data: this.result,
        type: 'bar',
        barWidth: '40%',
      },
    ];

    this.tableItems = tableResult.map((r) => ({
      docType: r.docType,
      docDate: Number(r.docDate) || 0,
      localDocAmount: Number(r.localDocAmount) || 0,
      storeLocation: r.storeLocation,
    }));

    this.generateLoadingText(1);

    this.saveHistory('series', 'xAxisData', 'tableItems');
  }

  public thousandFormatter(x) {
    return gdbx.currencySymbol + ' ' + Math.ceil(x).toLocaleString('en-US');
  }

}
